import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1fde767a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1fde767a&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=1fde767a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde767a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fde767a')) {
      api.createRecord('1fde767a', component.options)
    } else {
      api.reload('1fde767a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1fde767a&scoped=true", function () {
      api.rerender('1fde767a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leads/index.vue"
export default component.exports